<template lang="html">
  <vs-card class="cardx">
    <div slot="header" style="padding:10px">
      <h3>
        Partners
      </h3>
    </div>
    <div>
      <vs-table
        stripe
        search
        :sst="true"
        @search="handleSearch"
        :data="partners.partners">
        <template slot="thead">
          <vs-th sort-key="name">
            Name
          </vs-th>
          <vs-th sort-key="description">
            Description
          </vs-th>
          <vs-th>
            Action
          </vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="partner.id" v-for="partner in data"> 
            <vs-td>
              {{partner.name}}
            </vs-td>
            <vs-td>
              {{partner.description}}
            </vs-td>
            <vs-td>
              <!-- <feather-icon icon="EditIcon" @click="edit(partner.id)" class="cursor-pointer navbar-fuzzy-search mr-4" /> -->
              <feather-icon icon="Trash2Icon" @click="openConfirm(partner.id)" class="cursor-pointer navbar-fuzzy-search mr-4" />
              <feather-icon icon="TruckIcon" @click="showVehicles(partner.id)" class="cursor-pointer navbar-fuzzy-search mr-4" />
              <feather-icon icon="UserIcon" @click="showDrivers(partner.id)" class="cursor-pointer navbar-fuzzy-search mr-4" />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-3 mb-3">
        <pagination :last-page="partners.pagination.pages" v-model="filters.page" />
      </div>
    </div>
  </vs-card>
</template>


<script>
  import {mapActions, mapGetters, mapState} from 'vuex'
  import limitOptions from "../../constants/limit";

export default {
  name:  'Partners',
	data (){
		return {
		  page: 1,
      search : null,
      filters: {},
      limitOptions: limitOptions
		}
	},
	computed : {
		...mapState('partners',['partners','currentPage']),
    ...mapGetters('users',['userCan'])
	},
  created () {
    this.page = this.currentPage;
    this.filters = {
      limit: '20',
      ...this.$route.query,
      page: this.$route.query.page ? Number(this.$route.query.page) : 1,
    };
    this.doSearch = _.debounce(this.getItems,300);
    //this.getItems()
  },
  watch : {
    filters : {
      deep: true,
      handler(newVal, oldVal){
        this.setRouteQuery();
        //if(!_.isEqual(this.filters, this.last_filters))
          this.doSearch();
      }
    }
  },
	methods: {
		...mapActions('partners',['fetchPartners','deletePartner']),
    setRouteQuery(){
      let query = {...this.filters, page: `${this.filters.page}`};
      if(!_.isEqual(query, this.$route.query)){
        try{
          this.$router.push({query});
        }catch(error){

        }
      }
    },
    getItems(search){

      this.$vs.loading({type:'point'});
      this.fetchPartners(_.cloneDeep({page: this.filters.page, limit: 500}))
        .then(data=>{
        this.$vs.loading.close();
      })
      .catch(error=>{
        this.$vs.loading.close();
      })
    },
    handleSearch(searching){
		  this.filters = {...this.filters, page: 1, search: searching};
		  /*
      this.filters.page = '1';
      this.search = searching === '' ? null : searching;
      this.doSearch(searching);

		   */
    },
    openConfirm(id){
      if(!this.userCan('partners.delete')){
        this.$vs.notify({
          color: 'danger',
          title: `Error`,
          text: 'You need permission to perform this action',
        });
        return;
      }

      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Confirm`,
        text: "Are you sure yo want to delete this record?\n This cannot be undone!",
        accept:()=>{
          this.deletePartner({id})
            .then(data=>{
              this.$vs.notify({
                color:'success',
                title:'Success',
                text:'Deleted successfully'
              });
              this.getItems();
            })
            .catch(error=>{
              this.$vs.notify({
                color:'danger',
                title:'Error',
                text:'Something went wrong'
              })
            });
        }
      })
    },
    edit(id){
      this.$router.push({name: 'partners.edit', params:{id}})
    },
    showVehicles(partner_id){
      this.$router.push({name: 'vehicles List', query:{partner_id}})
    },
    showDrivers(partner_id){
      this.$router.push({name: 'drivers List', query:{partner_id}})
    },
	}

}
</script>
